import { HttpHeaders } from "@angular/common/http";

export const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'Basic ' + btoa('')
    })
} 

export const httpOptionsExcel = {
  headers: new HttpHeaders({
    'Authorization': 'Basic ' + btoa('')
  })
}  